module.exports = __webpack_public_path__ + "static/media/contact_icon_2.3c146066.svg";